
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infos-legales/mentions-legales",
      function () {
        return require("private-next-pages/infos-legales/mentions-legales.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/infos-legales/mentions-legales"])
      });
    }
  